import React, { useMemo, useRef, useState } from 'react';
import './AssignDemoTrialLicense.css';
import { IPartnerClinicDetails } from 'src/Utils/Hooks/GetPartnersInfo/GetPartnersClinics/useGetPartnersClinicsInfo';
import PopupDialog from 'src/SharedComponents/PopupDialog/PopupDialog';
import close from 'src/images/close.png';
import SearchBar from 'src/SharedComponents/SearchBar/SearchBar';
import TableHead from "src/SharedComponents/Table/TableHead";
import { useSearch } from "src/Utils/Hooks/SearchData/useSearch";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import Button from 'src/SharedComponents/Button/Button';
import useSortableData, { SortConfig } from 'src/Utils/Hooks/SortableData/useSortableData';

interface AssignDemoTrialLicenseProps {
    partnerClinics: IPartnerClinicDetails[];
    licenseType: string;
    onClose: () => void;
    onSubmit: (clinicId: string, licenseType: string, clinicName: string) => void;
}

interface IFilteredPartnerClinic {
    partnerName: string;
    clinicName: string;
    clinicId: string;
    country: string;
    distributorId: string;
}

const AssignDemoTrialLicense: React.FC<AssignDemoTrialLicenseProps> = ({partnerClinics, licenseType, onClose, onSubmit}) => {
    const [searchText, setSearchText] = useState<string>('');
    
    // Filter out partners with empty clinics and prepare the data
    const filteredData: IFilteredPartnerClinic[] = useMemo(() => {
        if (!partnerClinics) return [];
        return partnerClinics.filter(partner => partner.clinics && partner.clinics.length > 0)
            .flatMap(partner => partner.clinics.map(clinic => ({
                partnerName: partner.name,
                clinicName: clinic.name,
                clinicId: clinic.clinicId,
                country: clinic.countryName,
                distributorId: partner.distributorId
            })));
    }, [partnerClinics]);

    let conf: SortConfig<IFilteredPartnerClinic> = {
        key: 'partnerName',
        direction: 'ascending'
    };

    const searchKeys = useRef<(keyof IFilteredPartnerClinic)[]>(['partnerName', 'clinicName'])
    const filteredPartnersClinics = useSearch(filteredData, searchText, searchKeys.current);
    const { items, requestSort, sortConfig } = useSortableData(filteredPartnersClinics, conf);

    return (
        <div className="assignLicenseToPartner">
            <PopupDialog onClose={() => onClose()} marginTop="120px" popupWidth="45%">
                <div className="assign-license-header d-flex flex-column row">
                    <div className="row">
                        <div className="col-md-10">
                            <span style={{ fontWeight: '600', fontSize: '24px' }}>Assign Demo/Trial License</span>
                        </div>
                        <div className="col-md-2">
                            <i style={{ color: '#A8927D', cursor: 'pointer' }} onClick={() => { onClose() }}>
                                <img src={close} className='close-icon' alt="close" />
                            </i>
                        </div>
                    </div>
                    <div className="row ps-4" style={{ fontSize: '16px', color: '#A8927D', fontWeight: '400' }}>
                        Select a Partner
                    </div>
                    <div className="row mt-4">
                        <SearchBar onChange={(text:string) => {setSearchText(text) }} />
                    </div>
                </div>
                <div className="table-responsive" style={{overflowX:"hidden", borderRadius:'20px', marginBottom:'2px'}}>
                <table data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                        <thead className={`${tableStyles.tableHead}`}>
                            <tr key={'header'}>
                                <TableHead<IFilteredPartnerClinic>
                                    columnName="Partner" 
                                    paddingLeft="25px"
                                    requestSort={requestSort}
                                    sortConfig={sortConfig}
                                    columnkey="partnerName"
                                />
                                <TableHead<IFilteredPartnerClinic>
                                    columnName="Clinic" 
                                    paddingLeft="25px"
                                    requestSort={requestSort}
                                    sortConfig={sortConfig}
                                    columnkey="clinicName"
                                />
                                <TableHead<IFilteredPartnerClinic>
                                    columnName="Country"
                                    requestSort={requestSort}
                                    sortConfig={sortConfig}
                                    columnkey="country"
                                />
                                <th className={tableStyles.heading}>{ }</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((partner, i) => (
                                <tr key={i}>
                                    <td className={tableStyles.data} style={{width:"40%", paddingLeft:'25px' }}>
                                        {partner.partnerName}
                                    </td>
                                    <td className={tableStyles.data} style={{width:"30%", paddingLeft:'25px' }}>
                                        {partner.clinicName}
                                    </td>
                                    <td className={tableStyles.data} style={{width:"30%" }}>
                                        {partner.country}
                                    </td>
                                    <td className={tableStyles.data} style={{ fontWeight: 600}}>
                                        <Button
                                            backgroundColor="#A8927D"
                                            color="white"
                                            text="Assign"
                                            borderColor="none"
                                            fontSize="12px"
                                            width='127px'
                                            onClick={()=>onSubmit(partner.clinicId, licenseType, partner.clinicName)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        
                        </tbody>
                    </table>
                </div>
            </PopupDialog>
        </div>
    );
};

export default AssignDemoTrialLicense;